// Central location for all environment variables
const env = {
  // Logo URLs
  logoUrl: import.meta.env.VITE_LOGO_URL || 'https://legate-images.s3.us-west-2.amazonaws.com/cropped-Legate-Business-consulting-black-logo-1.png',
  footerLogoUrl: import.meta.env.VITE_FOOTER_LOGO_URL || 'https://legate-images.s3.us-west-2.amazonaws.com/Legate-Business-consulting-white-logo.png',
  
  // API endpoints
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3001', // Default to local dev server if not set
  
  // AWS Configuration for blog
  aws: {
    region: import.meta.env.VITE_AWS_REGION || 'us-west-2',
    bucketName: import.meta.env.VITE_BLOG_BUCKET_NAME || 'legate-blog-content',
    blogsPrefix: 'blogs/',
    imagesPrefix: 'blogs/images/',
    indexFile: 'blogs/blog-index.json',
    // Add downloads configuration
    downloadsPrefix: 'downloads/',
    downloadsIndexFile: 'downloads/index.json',
    downloadFilesPrefix: 'downloads/files/'
  },
  
  // Blog Configuration
  blog: {
    categories: [
      "Business Formation",
      "Legal",
      "Tax Planning",
      "Branding",
      "Finance",
      "Growth"
    ],
    defaultAuthor: {
      name: "Legate Business Consulting",
      role: "Business Formation Specialists",
      bio: "Legate Business Consulting helps entrepreneurs establish their businesses on solid legal ground with accessible, personalized support throughout the formation process."
    }
  },

  // Other configuration values
  isProd: import.meta.env.MODE === 'production',
  isDev: import.meta.env.MODE === 'development',
};

export default env;